import { render, staticRenderFns } from "./EventParticipantPage.vue?vue&type=template&id=1c0c45f1"
import script from "./EventParticipantPage.vue?vue&type=script&lang=js"
export * from "./EventParticipantPage.vue?vue&type=script&lang=js"
import style0 from "./EventParticipantPage.vue?vue&type=style&index=0&id=1c0c45f1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports